import React from 'react';
import './Header.css';
import logo from "../../assets/logo.png";

const Header = ({setIsJoining}) => {
  return (
    <div className='Header'>
      <div className='logo'>
        UbekaAI
      </div>
      <div className="actions">
        <button className='waitlist-btn' onClick={() => setIsJoining(true)}>Pre-Register</button>
      </div>
    </div>
  )
}

export default Header